// eslint-disable-next-line import/no-named-default
import { default as styled } from 'styled-components'
import { Form } from 'semantic-ui-react'
import { Components, Theme } from '@kyndio/kynd-shared-components'

const FooterContainer = styled.div`
  display: flex;
  justify-content: space-between;
  height: 2.3em;
  width: 100%;
`

const RightAlignWrapper = styled.div`
  text-align: right;
  display: flex;
  align-items: center;

  & > a {
    cursor: pointer;
    margin-left: 0.35em;
  }
`

const TermsCheckbox = styled(Form.Checkbox)`
& label {
  margin: 0.7em 0 0 0.35em;
}

& input:checked + label:after {
  top: -0.7em;
}
`

const SubmitContainer = styled.div`
  min-height: 2.3em;
  overflow: visible;
  align-items: center;
`

const SubmitButton = styled(Components.RegularButton)`
  float: right !important;
`

const DomainContainer = styled.span`
  margin-left: 0.35em;
`

const ErrorMessage = styled.div`
  color: ${Theme.colors.kynd.coral};
`

const EmailInput = styled(Form.Field)`
  & > div {
    display: inline-block;

    & input {
      text-align: right !important;
    }
  }
`

export {
  FooterContainer,
  RightAlignWrapper,
  TermsCheckbox,
  SubmitContainer,
  SubmitButton,
  DomainContainer,
  ErrorMessage,
  EmailInput
}
